import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-bridge-data-report',
    templateUrl: './bridgeDataReport.html',
    styleUrls: ['../../reports.css', './bridgeDataReport.css']
})

export class BridgeDataReportComponent implements OnInit {
    bridgeKeys: number[];
    reportData: any;
    private readonly todaysDate = new Date().toDateString();
    isGenerating = false;
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;

    constructor(private readonly reportsApi: ReportsApi,
                private readonly reportHelper: ReportHelper,
                private readonly route: ActivatedRoute,
                titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : Bridge Data Report');
    }

    async ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(x => {
            this.bridgeKeys = JSON.parse(window.localStorage.getItem(x.get('id'))).bridgeKeys;
            this.loadReport();
        });
    }

    private loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getBridgeDataReportData(this.bridgeKeys).then((reportData) => {
            this.reportData = reportData;
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }
}
